import React from 'react';

export default function PatternGrid({ patternStr, notesStr, rhythmNum, rhythmDen, noteLength = 8, activeIndex, focusedIndex, isEditable, onCellClick }) {
	const stepsPerBeat = Math.max(1, Math.round((noteLength || 8) / rhythmDen));

	return (
		<div className="sp-pattern-container">
			{Array.from({ length: rhythmNum }, (_, beatIdx) => (
				<div key={beatIdx} className="sp-beat-group">
					{Array.from({ length: stepsPerBeat }, (_, stepIdx) => {
						const idx = beatIdx * stepsPerBeat + stepIdx;
						if (idx >= patternStr.length) return null;

						const stroke = patternStr[idx];
						const note = notesStr[idx];

						let arrowContent = null;
						let arrowClass = 'sp-arrow-row';

						if (stroke === 'D') { arrowContent = '↓'; }
						else if (stroke === 'U') { arrowContent = '↑'; arrowClass += ' sp-up'; }
						else if (stroke === 'B') { arrowContent = <><span style={{ fontWeight: 700 }}>B</span><span>↓</span></>; arrowClass += ' sp-bass'; }
						else if (stroke === 'X') { arrowContent = 'X'; arrowClass += ' sp-mute'; }

						let colClass = 'sp-beat-col';
						if (isEditable && idx === focusedIndex) colClass += ' sp-focused';
						if (idx === activeIndex) colClass += ' sp-active';

						return (
							<div
								key={idx}
								className={colClass}
								data-index={idx}
								onClick={isEditable && onCellClick ? () => onCellClick(idx) : undefined}
							>
								<div className={arrowClass}>{arrowContent}</div>
								<div className="sp-text-row">{note}</div>
								
							</div>
						);
					})}
					<div className="sp-bracket" />
				</div>
			))}
		</div>
	);
}
